import { ref } from 'vue';

const useTab = (tab) => {
  const activeTab = ref(tab);

  const handleTabChange = (newTab) => {
    activeTab.value = newTab;
  };

  return [
    activeTab,
    handleTabChange,
  ];
};

export default useTab;
